var dfs = require("./dfs");

module.exports = preorder;

function preorder(g, vs) {
  return dfs(g, vs, "pre");
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/graphlib/lib/alg/preorder.js
// module id = 220
// module chunks = 0